import ApiService from "../../../ApiService";

const MessageService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/message/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    deletemessage: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/message/deletemessage", vo, successCallback, failureCallback);
    },
};

export default MessageService;